import * as React from 'react';
import { Svg } from '../svg';

function SvgSave({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.667 2.666h18.667a1.333 1.333 0 011.333 1.333v25.524a.666.666 0 01-1.021.566l-9.645-6.05-9.646 6.048a.667.667 0 01-1.021-.564V4a1.333 1.333 0 011.333-1.333zm17.334 2.667H8v20.576l8-5.015 8 5.015V5.333z"
        fill="currentColor"
      />
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgSave);
export default ForwardRef;
